import { GrowthBookProvider } from '@growthbook/growthbook-react';
import React, { useEffect, useState } from 'react';
import { FeatureFlagProviderContext } from './featureFlag.context';
import { growthBook } from './growthbook';

interface FeatureFlagProviderProps {
  children: React.ReactNode;
  segmentAnonymousId?: string;
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({ children, segmentAnonymousId }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!growthBook || !segmentAnonymousId) {
      return;
    }

    growthBook.setAttributes({ segmentAnonymousId });
    setIsInitialized(true);
  }, [segmentAnonymousId]);

  if (!growthBook) {
    return null;
  }

  return (
    <FeatureFlagProviderContext.Provider value={{ isInitialized }}>
      <GrowthBookProvider growthbook={growthBook}>{children}</GrowthBookProvider>
    </FeatureFlagProviderContext.Provider>
  );
};
